const mutations = {
  mutationAdditionalFeeRequest(state, payload) {
    state.additionalFeeRequest = payload;
  },

  mutationAdditionalFeeRequestList(state, payload) {
    if (payload && (payload.tab || payload.tab === 0)) {
      state.additionalFeeRequestList[payload.tab] = payload.responseData;
    } else {
      state.additionalFeeRequestList = payload;
    }
  },

  mutationAdditionalFeeRequestMeta(state, payload) {
    state.additionalFeeRequestMeta = payload;
  },
};

export default mutations;
